import { isPlatformBrowser } from '@angular/common';
import { Component, ComponentRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutPaymentTypeComponent } from '@spartacus/checkout/b2b/components';
import { CheckoutStepService } from '@spartacus/checkout/base/components';
import { GlobalMessageService, GlobalMessageType, HttpErrorModel, OccHttpErrorType, WindowRef } from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PaymentTypeCustom } from 'src/app/spartacus/custom/core/src/checkout/models/custom-checkout.model';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/spartacus/spartacus-custom.module';
import { ScriptService } from '../../../../../../custom/services/script.service';
import { CustomPaymentTypeService } from '../../../../core/src/checkout/facade/custom-payment-type.service';

declare global {
  interface Window {
    SequraConfiguration: any;
    Sequra: any;
    SequraOnLoad: any;
  }
}

@Component({
  selector: 'cx-payment-type',
  templateUrl: './custom-payment-type.component.html',
  styleUrls: ['./custom-payment-type.component.scss'],
  standalone: false
})

export class CustomPaymentTypeComponent extends CheckoutPaymentTypeComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  bannersSequra = false;
  component: ComponentRef<any>;
  totalWithTax: number;
  paymentTypes$: Observable<PaymentTypeCustom[]> = this.checkoutPaymentTypeFacade
    .getPaymentTypes()
    .pipe(
      tap(() => {
        this.paymentTypesError = false
        if (isPlatformBrowser(this.platformId)) {
          const timerId = setTimeout(() => {
            window.Sequra.refreshComponents();
            clearTimeout(timerId);
          }, 1500);
        }
        this.bannersSequra = true;
      }),
      catchError((error: HttpErrorModel) => {
        if (
          error.details?.[0]?.type === OccHttpErrorType.CLASS_MISMATCH_ERROR
        ) {
          this.globalMessageService.add(
            { key: 'httpHandlers.forbidden' },
            GlobalMessageType.MSG_TYPE_ERROR
          );
          this.paymentTypesError = true;
        }
        return of([]);
      })
    );


  constructor(
    protected checkoutStepService: CheckoutStepService,
    protected activatedRoute: ActivatedRoute,
    protected checkoutPaymentTypeFacade: CustomPaymentTypeService,
    protected launchDialogService: LaunchDialogService,
    protected globalMessageService: GlobalMessageService,
    protected vcr: ViewContainerRef,
    @Inject(PLATFORM_ID) private platformId: any,
    protected winRef: WindowRef,
    protected script?: ScriptService,
    protected activeCartService?: ActiveCartFacade
  ) {
    super(checkoutPaymentTypeFacade, checkoutStepService, activatedRoute, globalMessageService);
    this.subscriptions.add(this.activeCartService.getActive().subscribe(response => {
      this.totalWithTax = Math.round(100 * response?.totalPriceWithTax?.value);
    }));
  }

  ngOnInit() {
    this.checkoutPaymentTypeFacade.resetPaymentTypes();
  }

  changeType(code: any): void {
    this.launchLoader();
    this.typeSelected = code;

    this.checkoutPaymentTypeFacade
      .setPaymentType(code)
      .subscribe({
        complete: () => this.clearLoader(),
        error: () => this.clearLoader(),
      });
  }

  onLoadingStatusChange(event: boolean): void {
    event ? this.launchLoader() : this.clearLoader();
  }

  launchLoader(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.component) {
        this.clearLoader();
      }
      const component = this.launchDialogService.launch(
        CUSTOM_LAUNCH_CALLER.ORDER_ACTIONS_SPINNER, this.vcr
      );
      if (component) {
        component.subscribe((comp: ComponentRef<any>) => {
          this.component = comp;
        });
      }
    }
  }

  clearLoader(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.launchDialogService.clear(CUSTOM_LAUNCH_CALLER.ORDER_ACTIONS_SPINNER);
      this.component && this.component.destroy();
    }
  }

  next(): void {
    this.checkoutStepService.next(this.activatedRoute);
  }

  back(): void {
    this.checkoutStepService.back(this.activatedRoute);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.component && this.component.destroy();
      this.subscriptions.unsubscribe();
    }
  }
}
